/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component } from "react";
import AsignCard from "../../../../components/Card/Assign";
import { Modal, Popover } from "antd";
import postService from "./../../../../services/httpService";
import userTrackService from "../../../../services/usertrack-service";
import Storage from "../../../../services/local-store";
import {socket} from "./../../../../components/Card/Assign/index";
const { confirm } = Modal;
class QueuepatientDetailshell extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      queueitem: this.props.item,
      parentthis: this,
    };
  }
 
  componentDidUpdate(prevProps) {
    if (this.props.item.patients !== prevProps.item.patients) {
      let queueitem = this.state.queueitem;
      if (socket.readyState === WebSocket.OPEN) {
                console.log('WebSocket connection established didmount assign.');
                // this.onStartQ(queueitem, "withoutassign")
                const jsonString = JSON.stringify({data:queueitem,action:"assign"});
                socket.send(jsonString);
              };
      //this.refreshSingleQueue(queueitem, "assign");
    }
  }
  refreshQueueListData() {
    this.props.refreshQueueListData();
  }
  refreshData(QueueList, billingPatients) {
    this.props.refreshData(QueueList, billingPatients);
  }
  formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
  }
  checkReBuildQ(queueitem, that) {
    confirm({
      title: "Do you Want to Re-build the Queue ?",
      content: "",
      onOk() {
        let queuelistid = queueitem.queuelistid || "";
        if (queuelistid !== undefined && queuelistid !== null) {
        
          let obj = {
            queueListId: queuelistid,
          };
       
          let Userlogobj = {
            user: JSON.parse(Storage.get("user")),
            action: "restore queue",
            date: new Date(),
            meta: obj,
          };
          userTrackService(Userlogobj);
          postService("restoreQueueById", "POST", { data: obj }).then((res) => {
            let Userlogobjres = {
              user: JSON.parse(Storage.get("user")),
              action: "restore queue - response",
              date: new Date(),
              meta: res,
            };
            userTrackService(Userlogobjres);
            if (res) {
             
              if (socket.readyState === WebSocket.OPEN) {
                console.log('WebSocket connection established --rebuild.');
                // this.onStartQ(queueitem, "withoutassign")
                const jsonString = JSON.stringify({data:obj,action:"rebuild"});
                socket.send(jsonString);
              };
              //that.refreshSingleQueue(obj, "rebuild");
            }
          });
        }
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  }
  refreshSingleQueue(queueitem, action) {
    // console.log("Refresh Single Queue1");
    let queuelistid = queueitem.queuelistid || queueitem.queueListId;
    if (queuelistid !== undefined && queuelistid !== null) {
      let obj = {
        queueListId: queuelistid,
        action: action,
      };
      this.props.activateLoader();
      postService("refreshQueueById", "POST", { data: obj }).then((res) => {
        
        this.props.deActivateLoader();
        if (res) {
          let queueinfo = res.data || {};
          this.state.parentthis.setState({ queueitem: queueinfo });
        }
      });
    }
  }
  render() {
    let queueitem = this.state.parentthis.state.queueitem;
    let that = this;
    let rebuildStatus = queueitem.rebuildStatus;
    return (
      <div className="card mt-1 b-card">
        <div className="b-card-scroll">
          {rebuildStatus ? (
            <div class="m-3 px-3 py-1 b-card-body">
              <div class="row">
                <div class="col-12 py-4">
                  <div class="row">
                    <p class="text-error text-center col-12 error-color">
                      Please reset the Queue
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
          {queueitem.patients.map((item, index) => {
            let previous_patient_service_time = 0;
            let service_time, slottime;
            queueitem.patients.map((s, u) => {
              if (u < index) {
                let kservicetime = s.service_time || 0;
                previous_patient_service_time =
                  parseInt(previous_patient_service_time) +
                  parseInt(kservicetime);
              }
            });
            service_time = previous_patient_service_time;
            var dt = new Date();
            dt.setMinutes(dt.getMinutes() + service_time);
            slottime = this.formatAMPM(dt);
            return (
              <AsignCard
                {...this.props}
                item={item}
                queueitem={queueitem}
                singleQueueList={[queueitem]}
                itemindex={index}
                refreshData={this.refreshData.bind(this)}
                slottime={slottime}
                fullslottime={dt}
                key={index}
                activateLoader={this.props.activateLoader.bind(this)}
                deActivateLoader={this.props.deActivateLoader.bind(this)}
                refreshSingleQueue={this.refreshSingleQueue.bind(this)}
              />
            );
          })}
        </div>
        <div className="mx-3 mb-2 b-card-footer">
          <div className="row  m-0">
            <Popover
              overlayClassName="popover-custom"
              placement="topLeft"
              title={""}
              content={"Patients"}
            >
              <figure className="col py-2 my-auto mb-0 text-center active">
                <img
                  src={`/assets/images/icons/q-c-list-light.png`}
                  alt="list-style"
                />
              </figure>
            </Popover>
            <Popover
              overlayClassName="popover-custom"
              placement="top"
              title={""}
              content={"Refresh"}
            >
              <figure
                className="col py-2 my-auto mb-0 text-center"
                onClick={this.refreshSingleQueue.bind(
                  this,
                  queueitem,
                  "refresh"
                )}
              >
                <img src="/assets/images/icons/refresh.png" alt="refresh" />
              </figure>
            </Popover>
            <Popover
              overlayClassName="popover-custom"
              placement="topRight"
              title={""}
              content={"Reset Queue"}
            >
              <figure
                className="col py-2 my-auto mb-0 text-center"
                onClick={this.checkReBuildQ.bind(this, queueitem, that)}
              >
                <img src="/assets/images/icons/re_build.png" alt="rebuild" />
              </figure>
            </Popover>
          </div>
        </div>
      </div>
    );
  }
}

export default QueuepatientDetailshell;
